import BlockWrapper from "blocks/components/BlockWrapper";
import { BlockId } from "blocks/types";

export function BlockError(props: { blockId: BlockId }) {
  return (
    <BlockWrapper blockId={props.blockId} block={undefined}>
      <div className="rounded-xl bg-zi-white p-8 text-center font-mono text-sm shadow-xl">
        😲 Uh oh, this block had an error
      </div>
    </BlockWrapper>
  );
}
